module.exports = __webpack_public_path__ + "static/media/Polymedia-Peter_van_der_Meer.a51eb610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Polymedia-Peter_van_der_Meer.jpg
// module id = 2
// module chunks = 0